import React from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Ledger from "../components/Ledger";
import Missions from "../components/Missions";
import TradingPosts from "../components/TradingPosts";
import Calculator from "../components/Calculator";
import Legacy from "../components/Legacy";
import Footer from "../components/Footer";
import WhatsAppButton from "../components/WhatsAppButton";
import CallButton from "../components/CallButton";

export default function Home() {
  return (
    <div data-testid="home-page" className="min-h-screen">
      <Navbar />
      <Hero />
      <Ledger />
      <Missions />
      <TradingPosts />
      <Calculator />
      <Legacy />
      <Footer />
      <CallButton testid="home-call-fab" />
      <WhatsAppButton variant="floating" testid="home-whatsapp" />
    </div>
  );
}
